export enum ChartDataComparisonType {
  comparison = 'comparison',
  plan = 'plan',
}
